import type { VoidFunctionComponent } from 'react';
import { useSelector } from 'react-redux';
import { References } from '../../../shared/vulns/Drawer';
import * as IssuesV2Store from '../../../../redux/issuesV2';
import type { VulnIssue } from '../../../../../shared/issuesV2';

/**
 * VulnerabilityIssueDetailsReferences displays the references of the vulnerability
 * currently being viewed.
 */
const VulnerabilityIssueDetailsReferences: VoidFunctionComponent = () => {
  const activeIssue = useSelector(IssuesV2Store.selectors.getIssueDetails) as VulnIssue;

  if (!activeIssue) {
    return null;
  }

  return (
    <References
      references={activeIssue.references || []}
    />
  );
};

export default VulnerabilityIssueDetailsReferences;
